import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetDashboardDetails = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerDashboard/GetDashboardDetails`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const FetchPriceFromRNI = async (data) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `PartnerDashboard/FetchPriceFromRNI`, data, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetDashboard_BarChartTestDetails = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerDashboard/GetDashboard_BarChartTestDetails`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetDashboard_RAPieChartAccountBalanceDetails = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerDashboard/GetDashboard_RAPieChartAccountBalanceDetails`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetDashboard_TotalOutStandingPreviousMonth = async () => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `PartnerDashboard/GetDashboard_TotalOutStandingPreviousMonth`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetDashboard_TopTestDetails = async (selectedRevenueMonth) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerDashboard/GetDashboard_TopTestDetails_2?inputMonthStr=${selectedRevenueMonth}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetRA_TransactionCard = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `PartnerDashboard/GetRA_TransactionCard`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}



export const DashboardPatientTransactionData = async (data) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `PartnerDashboard/DashboardPatientTransactionData`, data, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetNotificationDet_ByPartnerCode = async (partner_code) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Notification/GetNotificationDet_ByPartnerCode?partner_code=${partner_code}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
